var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshCw = function SvgRefreshCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 2v3m0 0h-3m3 0L9.18 2.82A4.5 4.5 0 0 0 1.755 4.5M.5 10V7m0 0h3m-3 0 2.32 2.18a4.5 4.5 0 0 0 7.425-1.68"
  })));
};
export default SvgRefreshCw;